/**
Copyright [2022] [https://www.merac.com
 */
import config from '@/config'
import tool from '@/utils/tool'
import { findFirstMenuPath } from '@/utils/menu'

const routes = [
	{
		name: 'layout',
		path: '/admin',
		component: () => import('@/layout/index.vue'),
		redirect: findFirstMenuPath(tool.data.get('MENU') || []) || config.DASHBOARD_URL,
		children: [
			{
				name: 'messageWorkflowApproval',
				path: '/flw/todoTask',
				component: () => import('@/views/flw/task/todoTask/index.vue'),
				meta: { title: '审批处理', hidden: true }
			},
			{
				name: 'platformOpsConfig',
				path: '/platform/ops/config',
				component: () => import('@/views/dev/config/index.vue'),
				meta: { title: '基础配置', hidden: true }
			},
			{
				name: 'platformOpsFiles',
				path: '/platform/ops/files',
				component: () => import('@/views/dev/file/index.vue'),
				meta: { title: '文件资产', hidden: true }
			},
			{
				name: 'platformOpsEmail',
				path: '/platform/ops/email',
				component: () => import('@/views/dev/email/index.vue'),
				meta: { title: '邮件中心', hidden: true }
			},
			{
				name: 'platformOpsMessage',
				path: '/platform/ops/message',
				component: () => import('@/views/dev/message/index.vue'),
				meta: { title: '站内消息', hidden: true }
			},
			{
				name: 'platformOpsSms',
				path: '/platform/ops/sms',
				component: () => import('@/views/dev/sms/index.vue'),
				meta: { title: '短信中心', hidden: true }
			},
			{
				name: 'platformOpsDict',
				path: '/platform/ops/dict',
				component: () => import('@/views/dev/dict/index.vue'),
				meta: { title: '数据字典', hidden: true }
			},
			{
				name: 'platformOpsJobs',
				path: '/platform/ops/jobs',
				component: () => import('@/views/dev/job/index.vue'),
				meta: { title: '任务调度', hidden: true }
			},
			{
				name: 'platformOpsVislog',
				path: '/platform/ops/vislog',
				component: () => import('@/views/dev/log/vislog/index.vue'),
				meta: { title: '访问日志', hidden: true }
			},
			{
				name: 'platformOpsOplog',
				path: '/platform/ops/oplog',
				component: () => import('@/views/dev/log/oplog/index.vue'),
				meta: { title: '操作日志', hidden: true }
			},
			{
				name: 'platformOpsMonitor',
				path: '/platform/ops/monitor',
				component: () => import('@/views/dev/monitor/index.vue'),
				meta: { title: '系统监控', hidden: true }
			},
			{
				name: 'platformOpsChannels',
				path: '/platform/ops/channels',
				component: () => import('@/views/auth/channel/index.vue'),
				meta: { title: '渠道配置', hidden: true }
			},
			{
				name: 'platformOpsThirdUsers',
				path: '/platform/ops/third-users',
				component: () => import('@/views/auth/third/index.vue'),
				meta: { title: '三方用户', hidden: true }
			},
			{
				name: 'platformOpsChannelBindings',
				path: '/platform/ops/channel-bindings',
				component: () => import('@/views/auth/userchannelrelation/index.vue'),
				meta: { title: '渠道绑定', hidden: true }
			},
			{
				name: 'platformOpsSessions',
				path: '/platform/ops/sessions',
				component: () => import('@/views/auth/monitor/index.vue'),
				meta: { title: '会话治理', hidden: true }
			},
			{
				name: 'mrfrontdeskorders',
				path: '/biz/mrfrontdeskorders',
				component: () => import('@/views/biz/mrfrontdeskorders/index.vue'),
				meta: { title: '结单查询', hidden: true }
			}
		]
	},
	{
		path: '/login',
		component: () => import('@/views/auth/login/login.vue'),
		meta: {
			title: '登录'
		}
	},
	{
		path: '/findpwd',
		component: () => import('@/views/auth/findPwd/index.vue'),
		meta: {
			title: '找回密码'
		}
	},
	{
		path: '/callback',
		component: () => import('@/views/auth/login/callback.vue'),
		meta: {
			title: '三方登录'
		}
	}
]

export default routes
